




































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import DepartmentDialogComponent from '@/components/DepartmentDialogComponent.vue'
import { Department } from '@/domain/Department'
import DepartmentsService from '@/service/DepartmentsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    DepartmentDialogComponent,
  },
})
export default class MasterDepartmentList extends Mixins(GlobalMixin) {
  departmentsService = DepartmentsService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "部門コード", value: "code", width: "120px" },
          { text: "部門名", value: "name" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: Department[] = []
  rowItemKey = ""
  rowItemClickTime = 0

  dto: Department =  new Department()
  departmentDialog = false

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Department) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.code) {
      this.onEdit(event.code)
    }
    this.rowItemKey = event.code
    this.rowItemClickTime = now
  }

  /**
   * 新規作成
   */
  onNew() {
    this.departmentsService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.departmentDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.departmentsService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.departmentDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onDepartmentSubmit(dto: Department) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.departmentsService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.departmentsService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.departmentsService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
